import type { NameStyle } from '@hienbet/shared';
import { Logo } from './Logo.js';

/**
 * A viewer's name, wearing whatever they bought.
 *
 * The server sends tokens ("jade", "frozen") rather than colours, so the
 * palette lives here and can change without invalidating anyone's purchase. An
 * unknown token renders as a plain name rather than breaking the row —
 * cosmetics are decoration, and a bad one must never hide who placed a bet.
 */

export const COLORS: Record<string, string> = {
  frost: 'var(--frost)',
  jade: 'var(--money)',
  crimson: '#e2564f',
  violet: '#a97bff',
  ember: '#f0913c',
  mono: '#f2f6fa',
};

/** Name treatments that override a flat colour entirely. */
export const EFFECTS = new Set(['frozen', 'gilded', 'duotone']);

export const TITLES: Record<string, string> = {
  'anivia-truther': 'Anivia Truther',
  'professional-loser': 'Professional Loser',
  'house-money': 'House Money',
  'cold-blooded': 'Cold Blooded',
  'chalk-merchant': 'Chalk Merchant',
  degenerate: 'Degenerate',
  'egg-believer': 'Egg Believer',
  'down-bad': 'Down Bad',
};

export function PlayerName({
  name,
  style,
  showTitle = false,
}: {
  name: string;
  style?: NameStyle | undefined;
  showTitle?: boolean;
}) {
  const effect = style?.effect && EFFECTS.has(style.effect) ? style.effect : null;
  const color = !effect && style?.color ? COLORS[style.color] : undefined;
  // Their own words outrank a stock title — that is what they paid for.
  const title = style?.customTitle || (style?.title ? TITLES[style.title] : undefined);

  return (
    <span className="pn">
      <span className="pn-line">
        {style?.egg && (
          <span className="pn-egg" title="Egg holder">
            <Logo size={11} />
          </span>
        )}
        <span
          className={effect ? `pn-effect pn-effect-${effect}` : ''}
          style={color ? { color } : undefined}
        >
          {name}
        </span>
      </span>
      {showTitle && title && <span className="pn-title">{title}</span>}
    </span>
  );
}
